module.exports = __webpack_public_path__ + "assets/img/gd1.61c81cf8.jpg";